export const SHOW_EMAIL_CONFIRMATION_FORM =
  'showEmailConfirmationForm';
